import { Helmet } from 'react-helmet';
import { useIsAdmin } from '@/hooks/useIsAdmin';
import { AnalyticsSummaryWidget } from '@/components/admin/AnalyticsSummaryWidget';

const AdminDashboard = () => {
  const { isAdmin, loading } = useIsAdmin();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-pulse text-muted-foreground">Überprüfe Zugriffsrechte …</div>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md text-center space-y-4">
          <h1 className="text-2xl font-bold">Zugriff verweigert</h1>
          <p className="text-muted-foreground">
            Du bist derzeit nicht als Admin eingetragen.
            Bitte füge in der Supabase-Tabelle <code className="px-1.5 py-0.5 bg-muted rounded text-sm font-mono">user_roles</code> einen Eintrag hinzu:
          </p>
          <div className="bg-muted p-3 rounded-md">
            <code className="text-sm font-mono">role: 'admin'</code>
          </div>
          <p className="text-sm text-muted-foreground">
            Danach Seite neu laden – das Dashboard wird dann automatisch freigeschaltet.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Admin Dashboard</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      
      <div className="container mx-auto p-6 space-y-6">
        <div>
          <h1 className="text-3xl font-bold mb-2">Admin Dashboard</h1>
          <p className="text-muted-foreground">Interne Verwaltung & Statistiken</p>
        </div>

        <AnalyticsSummaryWidget />
      </div>
    </>
  );
};

export default AdminDashboard;
